import { render, staticRenderFns } from "./TitleDataDisplay.vue?vue&type=template&id=80351d38&scoped=true&"
import script from "./TitleDataDisplay.vue?vue&type=script&lang=js&"
export * from "./TitleDataDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TitleDataDisplay.vue?vue&type=style&index=0&id=80351d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80351d38",
  null
  
)

export default component.exports